import * as config from './config.js';
import * as env from './env.js';
import * as etl from './etl.js';
import * as flows from './flows.js';
import * as jobs from './jobs.js';
import * as snapshots from './snapshots.js';
import * as tenants from './tenants.js';

export const commands = [config, env, etl, flows, jobs, snapshots, tenants];
